import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentEventQuery } from '../../../event/hooks/useCurrentEventQuery';
import { Layout } from '../../../navigation/components/Layout/Layout';
import { useCurrentUserQuery } from '../../../user/hooks/useCurrentUserQuery';
import { TargetSwipe } from './components/TargetSwipe/TargetSwipe';

export const Targets: FunctionComponent = () => {
  const { data: currentUserData } = useCurrentUserQuery();
  const { data: currentEventQueryData } = useCurrentEventQuery();
  const navigate = useNavigate();

  if (
    !currentEventQueryData?.currentEvent?.isValidated ||
    !currentEventQueryData.currentEvent.isTargetEnabled
  ) {
    return null;
  }

  return (
    <Layout title="Targets" activeTab="target" noPadding>
      {currentUserData?.currentUser?.images?.length === 0 ? (
        <Card sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CardContent>
            <Typography>
              Vous devez ajouter des images avant de pouvoir swiper les targets.
            </Typography>
          </CardContent>
          <CardActions>
            <Button variant="contained" onClick={() => navigate('/images')}>
              Ajouter des images
            </Button>
          </CardActions>
        </Card>
      ) : (
        <>
          <Box sx={{ px: 0 }}>
            {currentEventQueryData?.currentEvent ? (
              <TargetSwipe eventId={currentEventQueryData.currentEvent.id} />
            ) : null}
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Button
              variant="contained"
              onClick={() => navigate('/target/stats')}
            >
              Voir les targets
            </Button>
          </Box>
        </>
      )}
    </Layout>
  );
};
